import {
  ChatAvailabilityResult,
  ChatEventType,
  CustomerChatMessage,
  Typenames,
} from '@varo/graphql-schema-types';

export enum ChatStatus {
  Online = 'online',
  Offline = 'offline',
  Down = 'error',
  Busy = 'fullqueue',
  Disabled = 'down_FF',
}

export const TRY_AGAIN_LATER = 'statusBanner.tryAgainLater';
export const WERE_WORKING_ON_IT = `statusBanner.wereWorkingOnIt`;
export const HELPING_OTHERS = 'statusBanner.helpingOthers';

export const OFFLINE_TITLE = 'statusBanner.offlineTitle';
export const DOWN_TITLE = 'statusBanner.downTitle';
export const BUSY_TITLE = 'statusBanner.busyTitle';

export const getBannerDescription = (status: ChatStatus): string => {
  switch (status) {
    case ChatStatus.Offline:
      return TRY_AGAIN_LATER;
    case ChatStatus.Down:
    case ChatStatus.Disabled:
      return WERE_WORKING_ON_IT;
    case ChatStatus.Busy:
      return HELPING_OTHERS;
  }
  return '';
};

export const getBannerTitle = (status: ChatStatus): string => {
  switch (status) {
    case ChatStatus.Offline:
      return OFFLINE_TITLE;
    case ChatStatus.Down:
    case ChatStatus.Disabled:
      return DOWN_TITLE;
    case ChatStatus.Busy:
      return BUSY_TITLE;
  }
  return '';
};

export const getStatusBanner = (chatAvailability?: ChatAvailabilityResult) => {
  let chatStatus: ChatStatus;

  switch (chatAvailability?.__typename) {
    case Typenames.ChatAvailabilitySuccess:
      chatStatus = ChatStatus.Online;
      break;
    case Typenames.ChatAvailabilityBusy:
      chatStatus = ChatStatus.Busy;
      break;
    case Typenames.ChatAvailabilityOffline:
      chatStatus = ChatStatus.Offline;
      break;
    case Typenames.ChatAvailabilityDisabled:
      chatStatus = ChatStatus.Disabled;
      break;
    default:
      chatStatus = ChatStatus.Down;
  }
  return chatStatus;
};

// Get the latest banner msg from history array to display the outage msg
export const getLatestBannerMsg = (messages: CustomerChatMessage[]) =>
  [...messages].find(
    (item: CustomerChatMessage) =>
      item.eventType === ChatEventType.SessionEnded,
  );
